import { loadModel } from "./ModelLoader";

export class AssetManager {

  constructor() {
    this.models = {};
  }

  async preload() {
    this.models.map = await loadModel("/assets/map.glb");
    this.models.office = await loadModel("/assets/office.glb");
    this.models.furniture = await loadModel("/assets/furniture.glb");
    this.models.location = await loadModel("/assets/location.glb");
    this.models.magnifier = await loadModel("/assets/magnifier.glb");
    this.models.pendrive = await loadModel("/assets/pendrive.glb");
    this.models.auth = await loadModel("/assets/auth.glb");
    this.models.chart = await loadModel("/assets/chart.glb");
  }

  getModel(name) {
    const gltf = this.models[name];
    if (!gltf) {throw new Error(`Model not loaded: ${name}`);}
    return gltf.scene.clone(true);
  }
}